import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { Field } from 'redux-form';

import RadioField from '../fields/RadioField';
import Heading from '../elements/PageHeading';
import renderError from '../elements/renderError';

import { types } from '../../utils/deviceTypes';

const Form = styled.div`
  margin-top: 50px;
  text-align: center;
`;

const DeviceTypePage = ({ t, handleSubmit }) => (
  <React.Fragment>
    <Heading text={t('device_type.title')} />
    <Form onSubmit={handleSubmit}>
      <fieldset>
        {Object.entries(types).map(([type, info]) => (
          <RadioField
            key={type}
            name="Type"
            type="radio"
            component="input"
            value={type}
            label={t(`device_type.${type}`)}
            icon={info.icon}
            data-device-type={type}
          />
        ))}
        <Field name="Type" component={renderError} />
      </fieldset>
    </Form>
  </React.Fragment>
);

export default translate()(DeviceTypePage);
